module.exports = __webpack_public_path__ + "img/star1blue.0f9eeaaf.png";